import { useBoxCollaborationDetailsQuery } from "../../../../../store/box/boxSlice";
import { pascalToSnakeCase } from "../../../../../utils";
import { useTableHooks } from "../../../../atoms/table/useTableHooks";
import { usePaginationHook } from "../../../../molecules/pagination/usePaginationHook";

interface collaborationHooksProps {
    email: string;
}

export const useCollaborationHooks = ({ email }: collaborationHooksProps) => {
    const {
        search:collaborationSearch,
        query:collaborationQuery,
        pageChangeHandler:collaborationPageChangeHandler,
        sortHandler:collaborationSortHandler,
        limitChangeHandler:collaborationLimitChangeHandler,
        searchHandler:collaborationSearchHandler,
    } = useTableHooks();

    const { data:collaboration, isLoading:collaborationLoading, isFetching:collaborationFetching } = useBoxCollaborationDetailsQuery({
        email,
        search: collaborationQuery.search,
        limit: collaborationQuery.limit,
        current_page: collaborationQuery.current,
        sort_by: pascalToSnakeCase(collaborationQuery.sortBy),
        sort_direction: collaborationQuery.sortDirection,
    });

    const {
        totalData:collaborationTotalData,
        handleFirstPage:collaborationHandleFirstPage,
        handlePrevPage:collaborationHandlePrevPage,
        handleLastPage:collaborationHandleLastPage,
        handleNextPage:collaborationHandleNextPage,
        renderPageNumbers:collaborationRenderPageNumbers,
    } = usePaginationHook({
        totalNumberOfData: collaboration?.result?.total,
        perPage: collaborationQuery.limit,
        setCurrentPage: collaborationPageChangeHandler,
        currentPage: collaborationQuery.current,
        className: "m-pagination",
    });

    const collaborationTableHeader = [
        {
            title: "Serial",
            dataIndex: "id",
            isSortable: true,
        },
        // {
        //     title: "Name",
        //     dataIndex: "name",
        //     isSortable: true,
        // },
        // {
        //     title: "Email",
        //     dataIndex: "email",
        //     isSortable: true,
        // },
        {
            title: "Owner Name",
            dataIndex: "ownerName",
            isSortable: true,
        },
        {
            title: "Owner Email",
            dataIndex: "ownerEmail",
            isSortable: true,
        },
        {
            title: "Status",
            dataIndex: "requestStatus",
            isSortable: true,
        },
        {
            title: "Permission",
            dataIndex: "permission",
            isSortable: true,
        },
        {
            title: "Item Type",
            dataIndex: "itemType",
            isSortable: true,
        },
        {
            title: "Item Name",
            dataIndex: "itemName",
            isSortable: true,
        },
        {
            title: "Inviter By",
            dataIndex: "inviterEmail",
            isSortable: true,
        },
        {
            title: "Invited Date",
            dataIndex: "inviteDate",
            isSortable: true,
        },
        {
            title: "Invite Accepted Date",
            dataIndex: "inviteAcceptedDate",
            isSortable: true,
        },
    ];

    return {
        collaborationSearch,
        collaborationQuery,
        collaborationSortHandler,
        collaborationLimitChangeHandler,
        collaborationSearchHandler,
        collaboration,
        collaborationLoading,
        collaborationFetching,
        collaborationTotalData,
        collaborationHandleFirstPage,
        collaborationHandlePrevPage,
        collaborationHandleLastPage,
        collaborationHandleNextPage,
        collaborationRenderPageNumbers,
        collaborationTableHeader
    };
};